import React from 'react';
import * as analytics from '../utils/analytics';

function isChunkLoadError(error) {
  if (!error) return false;
  const msg = String(error.message || '');
  return (
    error.name === 'ChunkLoadError' ||
    msg.includes('Loading chunk') ||
    msg.includes('Failed to fetch dynamically imported module')
  );
}

async function clearCachesUnregisterSwAndReload() {
  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch (e) {
    console.warn('Clear caches / unregister SW failed:', e);
  }
  window.location.reload();
}

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null, isChunkLoadError: false };

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
      isChunkLoadError: isChunkLoadError(error),
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    analytics.event('exception', { description: error?.message || 'Unknown', fatal: true });
  }

  render() {
    if (this.state.hasError) {
      const fallback = this.props.fallback;
      if (typeof fallback === 'function') return fallback(this.state.error);
      if (fallback) return fallback;

      const { isChunkLoadError: chunkErr } = this.state;

      return (
        <div className="container" style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>{chunkErr ? 'Update required' : 'Something went wrong'}</h2>
          <p style={{ marginBottom: '1rem' }}>
            {chunkErr
              ? 'This page could not load the latest app files. Clear cached files and reload.'
              : 'Check the browser console (F12) for details.'}
          </p>
          {chunkErr ? (
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => clearCachesUnregisterSwAndReload()}
            >
              Clear cache and reload
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-primary"
              onClick={() =>
                this.setState({ hasError: false, error: null, isChunkLoadError: false })
              }
            >
              Try again
            </button>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
